export default __webpack_public_path__ + "static/media/relax.36e32f5d.svg";